import { createStore } from '@reduxjs/toolkit'
import reducers from './reducers';
import accountReducer from './reducers/accountReducer';
import calculationsReducer from './reducers/calculationsReducer';
import combineReducers from './reducers/index';
export default createStore(
  combineReducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)
